<template>
  <!-- 认证弹窗certification -->
  <div class="certification">
    <el-dialog
      title="重置密码"
      width="366px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <img src="../../assets/img/重置密码.png" alt="" />
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item prop="LoginPwd" label="密码:">
          <el-input
            v-model="form.LoginPwd"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="restPwd" label="确认密码:">
          <el-input
            v-model="form.restPwd"
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- <el-form-item> -->
      <el-button
        type="primary"
        class="submitStyle"
        @click="NextStep"
        v-loading="loading"
        >确定</el-button
      >
      <!-- </el-form-item> -->
    </el-dialog>
  </div>
</template>

<script>
// 引入接口
import {
  SearchLoginCodeExistOrNot,
  GetMailBoxVerificationCode,
  GetVerificationCode,
  ResetPassword
} from "@/api/user.js";
const TIME_COUNT = 60;
export default {
  name: "certification",
  props: {
    loginsInfo: {
      // 表格数据
      type: Object,
      default: function() {
        return {};
      }
    },
    restPhone: {
      type: String,
      default: ""
    }
  },
  data() {
    var repasswordValidator = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value != this.form.LoginPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 表单数据
      form: {
        LoginPwd: "",
        restPwd: ""
      },
      validation: {
        Phone: "",
        VerificationCode: ""
      },
      rules: {
        LoginPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        restPwd: [{ validator: repasswordValidator, trigger: "blur" }]
      },
      loading: false
    };
  },
  computed: {
    hasToken: {
      get() {
        return this.$store.state.users.token;
      }
    },
    userInfos: {
      get() {
        return this.$store.state.users.userInfo;
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.loginsInfo.dialogVisible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    handleConfirm() {
      // this.$refs.mychild.submitForm();
      // 触发父组件的方法 点击保存的方法
      this.$emit("confirm");
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("Cancel");
      this.$emit("update:visible", false);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    // 下一步
    NextStep() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form = { ...this.form, LoginCode: this.restPhone };
          console.log(this.form);
          ResetPassword(this.form)
            .then(res => {
              if (res.Code === 0) {
                this.$message({
                  message: res.Msg,
                  type: "success"
                });
                this.dialogVisible = false;
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>

<style>
.messageIndex {
  margin-top: 80px;
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
.el-message {
  top: 20px !important;
}
.el-message:not(:last-child) {
  visibility: hidden;
}
</style>

<style lang="less" scoped>
.submitStyle {
  margin-top: 50px;
}
/deep/ .el-form-item__label {
  line-height: 60px;
}
/deep/ .el-form-item {
  display: flex;
  border-bottom: 1px solid #ebebeb;
}
.CheckMailbox {
  text-align: left;
  padding: 0px 30px;
  margin: 0px;
  color: #313131;
  width: 246px;
}
.el-dialog__body {
  padding: 10px 10px;
}
.ForgetPassword {
  text-align: right;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5b90f0;
}
/deep/ .messageIndex {
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
/deep/.el-dialog__header {
  padding: 65px 20px 10px;
}
/deep/.el-dialog {
  width: 366px;
  // height: 460px;
  background: #ffffff;
  border-radius: 10px;
}

.certification {
  position: relative;
  // background: url(../../assets/img/盾牌保险认证.png) no-repeat;
  // background-size: 20px 20px;
  // top: 0px;
  img {
    position: absolute;
    top: 68px;
    left: 120px;
  }
  .code {
    position: absolute;
    top: 305px;
    left: 200px;
  }
  .msg_btn {
    position: absolute;
    top: 230px;
    left: 200px;
  }
}
.certification /deep/.el-input__inner {
  // margin-bottom: 29px;
  background-color: #fff;
  border: none;
  border-radius: 1px;
  // width: 266px;
  /* border: 1px solid #dcdfe6; */
  height: 60px;
  line-height: 60px;
  // border-bottom: 1px solid #ebebeb;
}
.el-button--primary {
  width: 266px;
  height: 40px;
  background: #5b90f0;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  text-align: center;
}
/deep/.el-form-item__content {
  margin: 0px 0px 0px !important;
}
.el-input__prefix,
.el-input__suffix {
  height: 0px !important;
}
// 错误提示
/deep/.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 30px !important;
}
// 按钮上边距
.el-button--primary[data-v-35056f12] {
  margin-top: 10px !important;
}
// 复选框，选中
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #656565;
}
// 用户协议
.UserAgreement {
  cursor: pointer;
  color: #5b90f0;
}
</style>

<style scoped lang="less">
/deep/.el-dialog__header {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/ResetPassword.vue